<template>
  <input
    class="input"
    :value="value"
    @input="$emit('input', $event.target.value)"
    :type="type"
    :placeholder="placeholder"
    :required="required"
  />
</template>

<script>
export default {
  props: {
    value: String,
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String
    },
    required: Boolean
  }
}
</script>

<style lang="scss">
.input {
  border: 2px solid transparent;
  background-color: white;
  padding: 8px 12px;
  font-size: 20px;
  border-radius: 6px;
  width: 80%;
  outline: none;

  &:focus {
    border: 2px solid blue;
    box-shadow: 0px 0px 10px 2px rgba(128, 121, 128, 1);
  }

  &:hover {
    box-shadow: 0px 0px 10px 2px rgba(128, 121, 128, 1);
  }
}
</style>
